import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateManagedMethod, UpdateManagedMethodParams} from '../api';
import {QUERY__MANAGED_METHODS} from '../queryKeys';
import {ManagedMethodKind} from '../types';

export const useUpdateManagedMethod = (kind: ManagedMethodKind) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: Omit<UpdateManagedMethodParams, 'kind'>) =>
      updateManagedMethod({...params, kind}),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__MANAGED_METHODS, kind],
      });
    },
  });
};
